<template>
	<div>
		<div id="header-common" :style="{ backgroundImage: 'url(' + srcImage + ')' , height: tall + 'px' }"  >
		<div class="container">
			<div class="h1" name="resources_btn" :class="{ accordionsNot: !isAccordions ,accordionsYes: isAccordions }">
				<h1>{{h1}}</h1>
			</div>
			<slot></slot>
		</div>
	</div>
	</div>
</template>

<script>
export default {
	props: [ 'srcImage', 'tall', 'h1', 'isAccordions' ]
}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/commonSite/header.vue